import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router
} from '@angular/router';
import { LoggingService } from '@app/core/services/logging.service';
import { UnityDirectStateService } from '@app/core/services/unity-direct-state.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {
  navigationInProgress: boolean;
  _unsubscribe: Subject<boolean> = new Subject<boolean>();
  constructor(
    private route: Router,
    private ls: LoggingService,
    private udStateService: UnityDirectStateService
  ) {}

  ngOnInit(): void {
    this.route.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.navigationInProgress = true;
        this.udStateService.isNavInProgress = true;
        this.udStateService.navInProgressSubject.next(true);
        this.ls.sendInfoLevelMessage('Loading Start');
      }
      if (event instanceof NavigationEnd) {
        this.navigationInProgress = false;
        this.udStateService.isNavInProgress = false;
        this.udStateService.navInProgressSubject.next(false);
        this.ls.sendInfoLevelMessage('Loading Complete');
      }
      if (event instanceof NavigationError) {
        this.navigationInProgress = false;
        this.udStateService.isNavInProgress = false;
        this.udStateService.navInProgressSubject.next(false);
        this.ls.sendInfoLevelMessage('Loading Error');
      }
    });
  }
  ngOnDestroy(): void {
    this._unsubscribe.next();
  }
}
